export default {
      id: "ic-statistics-on-usage",
      viewBox: "0 0 32 32",
      url: "/" + "images/icons.3.109.2.svg#ic-statistics-on-usage",
      toString: function () {
        return this.url;
      }
    }